import React from 'react';
import Layout from '../../components/Layout';
import HowItWorks from './HowItWorks';

const title = 'How BestHand Works — Book a Trusted Local Pro';
// COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod.
const description =
  'See how BestHand works: tell us the job, pick a time, and get matched with a vetted, background-checked local pro in under 60 seconds. Pay securely in-app.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <HowItWorks />
      </Layout>
    ),
  };
}

export default action;
